import React, { useState, useEffect } from 'react';
import { withLocalize } from 'react-localize-redux';
import HeaderPage from '../HeaderPage/HeaderPage';
import Footer from '../../../_Common/Footer';
import './MealPlanPage.css';

const MealPlanPage = () => {
    const [formData, setFormData] = useState({});
    const [userName, setUserName] = useState('');
    const [mealPlan, setMealPlan] = useState([]);

    const searchParams = new URLSearchParams(window.location.search);
    const bNewShoppingList = searchParams.get('bNewShoppinglist') === 'true';

    const [selectedItems, setSelectedItems] = useState({});
    const [showQuantityPopup, setShowQuantityPopup] = useState(false);
    const [currentMeal, setCurrentMeal] = useState(null);
    //const [tempQuantity, setTempQuantity] = useState(1);

    const [servings, setServings] = useState(1);

    const incrementServings = () => setServings(s => s + 1);
    const decrementServings = () => setServings(s => (s > 1 ? s - 1 : 1));

    const handleDeleteMeal = async (mealId) => {
        const confirmed = window.confirm("Are you sure you want to delete this meal?");
        if (!confirmed) return; // Exit if user cancels

        const storedUser = localStorage.getItem('userDetails');
        if (!storedUser) return;

        const user = JSON.parse(storedUser);
        const fullName = `${capitalize(user.sFirstName)}`;
        setFormData(user);
        setUserName(fullName);

        try {
            const url = `https://nutritrustapi.azurewebsites.net/api/Menu/DeleteMealPlan?iMealId=${encodeURIComponent(mealId)}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'apikey': 'A3BDF392-1EA2-4A8E-BD67-2B985D4CBD6C',
                    'aspnetuserid': user.sUserId,
                },
            });

            if (!response.ok) {
                throw new Error(`Delete failed with status ${response.status}`);
            }

            // Update state
            setMealPlan(prev => prev.filter(meal => meal.id !== mealId));

            setSavedListItems(prev => {
                const updated = { ...prev };
                delete updated[mealId];
                return updated;
            });

            setSelectedItems(prev => {
                const updated = { ...prev };
                delete updated[mealId];
                return updated;
            });

        } catch (error) {
            console.error('Error deleting meal plan:', error);
            alert('Failed to delete the meal. Please try again.');
        }
    };

    const handleCheckboxChange = (meal) => {
        setCurrentMeal(meal);
        //setTempQuantity(1);
        setServings(1);
        setShowQuantityPopup(true);
    };

    const [savedListItems, setSavedListItems] = useState({});

    const updateMealPlans = async () => {
        try {
            const storedUser = localStorage.getItem('userDetails');
            const shoppingList = localStorage.getItem('shoppingList');

            if (!storedUser || !shoppingList) {
                console.warn('Missing user or shopping list data');
                return;
            }

            const user = JSON.parse(storedUser);
            const meals = JSON.parse(shoppingList); // expected format: [{ id, quantity }, ...]

            const response = await fetch('https://nutritrustapi.azurewebsites.net/api/Menu/UpdateMealPlans', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'apikey': 'A3BDF392-1EA2-4A8E-BD67-2B985D4CBD6C',
                    'aspnetuserid': user.sUserId,
                },
                body: JSON.stringify({
                    sUserId: user.sUserId,
                    meals: meals
                }),
            });

            if (!response.ok) {
                throw new Error(`API responded with status ${response.status}`);
            }

            const result = await response.json();
            console.log('Meal plans updated successfully:', result);
            return result;
        } catch (error) {
            console.error('Error updating meal plans:', error);
            throw error;
        }
    };

    useEffect(() => {
        document.title = "MyMenuMoonshot - Meal Plan";

        const storedUser = localStorage.getItem('userDetails');
        if (storedUser) {
            const user = JSON.parse(storedUser);

            // ✅ Fetch meal plan and store active items in localStorage
            fetch(`https://nutritrustapi.azurewebsites.net/api/Menu/GetMealPlans?sUserId=${user.sUserId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'apikey': 'A3BDF392-1EA2-4A8E-BD67-2B985D4CBD6C',
                    'aspnetuserid': user.sUserId,
                },
            })
                .then(response => {
                    if (!response.ok) throw new Error('Failed to fetch meal plan');
                    return response.json();
                })
                .then(mealPlanRaw => {
                    const mealPlan = mealPlanRaw?.meals || [];

                    const activeItems = mealPlan
                        .filter(meal => meal.is_active === true)
                        .map(meal => ({
                            id: meal.id,
                            quantity: meal.quantity
                        }));

                    console.log('Active items:', activeItems);

                    if (activeItems.length > 0) {
                        localStorage.setItem('shoppingList', JSON.stringify(activeItems));
                    }

                    setMealPlan(mealPlan);
                })
                .catch(error => {
                    console.error('Error loading meal plan:', error);
                });

            const fullName = `${capitalize(user.sFirstName)}`;
            setFormData(user);
            setUserName(fullName);
        }

        // ✅ 🛑 Only restore saved items if we're *not* starting a new list
        if (!bNewShoppingList) {
            const savedList = localStorage.getItem('shoppingList');
            if (savedList) {
                try {
                    const parsedList = JSON.parse(savedList);
                    const savedItemsObj = {};
                    parsedList.forEach(item => {
                        savedItemsObj[item.id] = item.quantity;
                    });
                    setSavedListItems(savedItemsObj);
                    setSelectedItems(savedItemsObj);
                } catch (e) {
                    console.error('Invalid shopping list in localStorage');
                }
            }
        } else {
            // If explicitly starting new list, clear everything
            setSavedListItems({});
            setSelectedItems({});
        }
    }, []);


    const capitalize = (str) =>
        typeof str === 'string' ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : '';

    const renderMealPlan = () => {
        return (
            <div className="shopping-list">
                {bNewShoppingList && (
                    <h4>Choose Recipes for Shopping List:</h4>
                )}
                {Object.keys(savedListItems).length > 0 && (
                    <h4>Shopping List Items</h4>
                )}
                {mealPlan.map((meal, index) => {
                    const isSelected = selectedItems[meal.id];
                    const savedQuantity = savedListItems[meal.id];
                    const isSaved = savedQuantity !== undefined;

                    return (
                        <div
                            key={index}
                            className={`meal-card ${isSaved ? 'highlighted-card' : ''}`}
                            id={meal.id}
                            name={meal.id}
                            onClick={() => {
                                if (bNewShoppingList) return;

                                const menuItemId = meal.menu_item_id; // ✅ Correct ID for linking
                                const mealPlanId = meal.id;
                                const url = meal.sURL;

                                if (meal.quantity > 1) {
                                    localStorage.setItem('bMultiServing', true);
                                } else {
                                    localStorage.setItem('bMultiServing', false);
                                }

                                localStorage.setItem('sURL', url);
                                localStorage.setItem('bUseURL', true);
                                
                                window.location.href = `/menu-item/${menuItemId}/611/${mealPlanId}`;
                            }}
                        >
                            {bNewShoppingList && (
                                <label
                                    htmlFor={`meal-check-${meal.id}`}
                                    className={`custom-checkbox-label ${isSelected ? 'checked' : ''}`}
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <input
                                        type="checkbox"
                                        id={`meal-check-${meal.id}`}
                                        checked={!!isSelected}
                                        onChange={(e) => {
                                            e.stopPropagation();
                                            if (e.target.checked) {
                                                handleCheckboxChange(meal);
                                            } else {
                                                const updated = { ...selectedItems };
                                                delete updated[meal.id];
                                                setSelectedItems(updated);
                                            }
                                        }}
                                    />
                                    <i className={`fa fa-solid ${isSelected ? 'fa-square-check' : 'fa-square'}`}></i>
                                </label>
                            )}

                            <div className="meal-text">
                                <h4 className="meal-name">{meal.name}</h4>

                                {/* Pills display */}
                                {meal.sPills && (
                                    <div className="col-xs-12 mbPill" style={{ display: 'block' }}>
                                        {meal.sPills.split('|').map((pill, index) => (
                                            <span key={index} className="pill xpill" style={{ display: 'inline-block' }}>
                                                {pill.trim()}
                                            </span>
                                        ))}
                                    </div>
                                )}

                                {bNewShoppingList && selectedItems[meal.id] && (
                                    <p><strong>Selected Quantity:</strong> {selectedItems[meal.id]}</p>
                                )}

                                {!bNewShoppingList && isSaved && (
                                    <p><strong>Servings:</strong> {savedQuantity}</p>
                                )}

                                {!bNewShoppingList && !isSaved && (
                                    <button
                                        className="delete-meal-btn"
                                        onClick={(e) => {
                                            e.stopPropagation(); // Prevent redirect
                                            handleDeleteMeal(meal.id);
                                        }}
                                    >
                                        Delete
                                    </button>
                                )}
                            </div>

                            {meal.image && (
                                <img
                                    src={`https://res.cloudinary.com${meal.image}`}
                                    alt={meal.name}
                                    className="meal-image"
                                />
                            )}
                        </div>
                    );
                })}
            </div>
        );
    };

    const renderQuantityPopup = () => {
        if (!showQuantityPopup || !currentMeal) return null;

        return (
            <div className="popup-overlay">
                <div className="popup-content">
                    <h3>Select Quantity for {currentMeal.name}</h3>
                    <div className="servings-control">
                        <button onClick={decrementServings}>−</button>
                        <button onClick={incrementServings}>+</button>
                        <span style={{ marginLeft: '1rem', fontSize: '16px', fontWeight: 'bold' }}>
                            {servings} {servings === 1 ? 'Serving' : 'Servings'}
                        </span>
                    </div>
                    <input
                        type="number"
                        min="1"
                        value={servings}
                        style={{ display: "none" }}
                    />
                    <div className="popup-buttons">
                        <button className="save-quantity-btn"
                            onClick={() => {
                                setSelectedItems(prev => ({
                                    ...prev,
                                    [currentMeal.id]: servings
                                }));
                                setShowQuantityPopup(false);
                                setCurrentMeal(null);
                            }}
                        >
                            Save
                        </button>
                        <button className="cancel-quantity-btn"
                            onClick={() => {
                                setShowQuantityPopup(false);
                                setCurrentMeal(null);
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="App MealPlanPage">
            <HeaderPage setFormData={formData} />
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="inner_page_innersec">
                            <h2>{userName}'s MyMenu Selections</h2>
                            {Object.keys(savedListItems).length > 0 ? (
                                //<h2 style={{ marginTop: '10px' }}>
                                //    Your menu items are saved to the <a href="/shopping-list">shopping list</a>!
                                //</h2>
                                <div
                                    className="continue_search_landing event active shopping_btns"
                                    onClick={e => {
                                        window.location.replace('/shopping-list');
                                    }
                                    }
                                >
                                    <i className="fa fa-cart-shopping fa-small"></i> View Shopping List
                                </div>

                            ) : (
                                Object.keys(selectedItems).length > 0 && (
                                    <button
                                        className="continue_search_landing event active save-shopping-list-btn shopping_btns"
                                        onClick={async () => {
                                            const shoppingList = Object.entries(selectedItems).map(([id, quantity]) => ({
                                                id,
                                                quantity
                                            }));

                                            localStorage.setItem('shoppingList', JSON.stringify(shoppingList));
                                            try {
                                                await updateMealPlans();
                                                window.location.href = '/meal-plan'; // Redirect after saving
                                            } catch (e) {
                                                alert('Failed to save your shopping list. Please try again.');
                                            }
                                        }}
                                    >
                                        <i className="fa fa-cart-shopping fa-small"></i> Save Shopping List
                                    </button>


                                )
                            )}


                            {bNewShoppingList ? (
                                <div
                                    className="continue_search_landing event active shopping_btns"
                                    onClick={() => {
                                        // Cancel action: go back to regular meal-plan (remove param)
                                        window.location.replace('/meal-plan');
                                    }}
                                >
                                    Cancel
                                </div>
                            ) : (
                                <div
                                    className="continue_search_landing event active shopping_btns"
                                    onClick={e => {
                                        const confirmed = window.confirm("A new shopping list will be created. Are you sure you want to continue?");
                                        if (confirmed) {
                                            localStorage.removeItem('shoppingList');
                                            setSelectedItems({});
                                            setSavedListItems({});
                                            window.location.replace('/meal-plan?bNewShoppinglist=true');
                                        }
                                    }}
                                >
                                    <i className="fa fa-cart-shopping fa-small"></i> New Shopping List
                                </div>
                            )}

                            

                            {renderMealPlan()}
                            {renderQuantityPopup()}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default withLocalize(MealPlanPage);
